/**
 * 播放历史上报：开始/停止定时、单次记录、进度记录
 * 抽离自 MusicPlayer.js，调用方传入 axios、getUserId、getActiveMediaElement 等依赖
 */

/**
 * 开始播放历史跟踪：每 PLAY_HISTORY_INTERVAL_MS 检查一次，满 30 秒则调用 recordPlayProgress
 * @param {React.MutableRefObject<ReturnType<typeof setInterval>|null>} playHistoryIntervalRef
 * @param {function(boolean, React.RefObject, React.RefObject): HTMLMediaElement|null} getActiveMediaElement
 * @param {boolean} hasVideo
 * @param {React.RefObject} videoRef
 * @param {React.RefObject} audioRef
 * @param {object|null} currentMusic
 * @param {function(number, number): Promise<void>} recordPlayProgress
 * @param {number} PLAY_HISTORY_INTERVAL_MS
 */
export function startPlayHistoryTracking(
  playHistoryIntervalRef,
  getActiveMediaElement,
  hasVideo,
  videoRef,
  audioRef,
  currentMusic,
  recordPlayProgress,
  PLAY_HISTORY_INTERVAL_MS
) {
  if (playHistoryIntervalRef.current) return;

  let startTime = Date.now();

  playHistoryIntervalRef.current = setInterval(() => {
    const mediaElement = getActiveMediaElement(hasVideo, videoRef, audioRef);
    if (mediaElement && currentMusic) {
      const currentPosition = mediaElement.currentTime;
      const playDuration = (Date.now() - startTime) / 1000;
      if (playDuration >= 30) {
        recordPlayProgress(currentPosition, playDuration);
        startTime = Date.now();
      }
    }
  }, PLAY_HISTORY_INTERVAL_MS);
}

/**
 * 停止播放历史跟踪
 * @param {React.MutableRefObject<ReturnType<typeof setInterval>|null>} playHistoryIntervalRef
 */
export function stopPlayHistoryTracking(playHistoryIntervalRef) {
  if (playHistoryIntervalRef.current) {
    clearInterval(playHistoryIntervalRef.current);
    playHistoryIntervalRef.current = null;
  }
}

/**
 * 记录播放开始（单次上报）
 * @param {object|null} currentMusic
 * @param {import('axios').default} axios
 * @param {function(): string|null} getUserId
 */
export async function recordPlay(currentMusic, axios, getUserId) {
  if (!currentMusic) return;
  try {
    const userId = getUserId();
    await axios.post(`/api/music/${currentMusic.id}/play`, {
      position: 0,
      duration: 0,
      completed: 0
    }, {
      headers: { 'X-User-ID': userId }
    });
  } catch (error) {
    console.error('Record play error:', error);
  }
}

/**
 * 记录播放进度（每 30 秒上报）
 * @param {object|null} currentMusic
 * @param {number} position
 * @param {number} playDuration
 * @param {import('axios').default} axios
 * @param {function(): string|null} getUserId
 */
export async function recordPlayProgress(currentMusic, position, playDuration, axios, getUserId) {
  if (!currentMusic) return;
  try {
    const userId = getUserId();
    await axios.post(`/api/music/${currentMusic.id}/play`, {
      position: Math.floor(position),
      duration: Math.floor(playDuration),
      completed: 0
    }, {
      headers: { 'X-User-ID': userId }
    });
  } catch (error) {
    console.error('Record play progress error:', error);
  }
}
